import React, { FC } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { globalTheme } from '@cld/component-theme';
import { Icon } from '@cld/icon';
import { useAnalytics } from '../../../../hooks/useAnalytics';
import { messages } from '../../../../i18n';
import { Link } from './Link';

const Root = styled.div`
  width: calc(${globalTheme.spacing.lg} * 5);
`;

const LinkWrapper = styled.div`
  margin-bottom: ${globalTheme.spacing.sm}
`;

const IconsContainer = styled.div`
  & > * {
    padding: ${globalTheme.spacing.xxs};
  }
`;

export const Contact: FC = () => {
  const analytics = useAnalytics();

  return (
    <Root>
      <LinkWrapper>
        <Link
          href="https://cloudinary.com/contact"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => analytics('navigation', 'contact us')}
          data-test="footer-contact-us-link"
        >
          <FormattedMessage {...messages['landing.footer.links.contactUs']} />
        </Link>
      </LinkWrapper>
      <IconsContainer>
        <Link
          href="https://www.facebook.com/Cloudinary"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => analytics('external navigation', 'facebook')}
          data-test="footer-facebook-link"
        >
          <Icon name="facebook" size="lg" />
        </Link>
        <Link
          href="https://twitter.com/cloudinary"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => analytics('external navigation', 'twitter')}
          data-test="footer-twitter-link"
        >
          <Icon name="twitter" size="lg" />
        </Link>
        <Link
          href="https://www.linkedin.com/company/cloudinary/"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => analytics('external navigation', 'linkedin')}
          data-test="footer-linked-in-link"
        >
          <Icon name="linkedIn" size="lg" />
        </Link>
      </IconsContainer>
    </Root>
  );
};
